import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_form = _resolveComponent("login-form")!
  const _component_RegisterModal = _resolveComponent("RegisterModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_ctx.$route.name === 'home')
      ? (_openBlock(), _createBlock(_component_login_form, {
          key: 0,
          onRecoverPassword: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('recoverPassword', $event))),
          onToggleRegisterModal: $setup.toggleRegisterModal,
          onToggleLogin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleLogin', $event)))
        }, null, 8, ["onToggleRegisterModal"]))
      : _createCommentVNode("", true),
    ($setup.isRegisterModalOpen)
      ? (_openBlock(), _createBlock(_component_RegisterModal, {
          key: 1,
          onToggleRegisterModal: $setup.toggleRegisterModal
        }, null, 8, ["onToggleRegisterModal"]))
      : _createCommentVNode("", true)
  ]))
}